import { BaseStateProps } from "data/interface";

export interface AppItem {
  id: number;
  name: string;
  appUrl: string;
  imageURL: string;
  rewardPoints: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  trackingUrl: string;
}

export interface AppsStateProps extends BaseStateProps {
  isError: boolean;
  apps: AppItem[];
  fetchedApps: boolean;
}

export const initialState: AppsStateProps = {
  isFetching: false,
  isError: false,
  fetchedApps: false,
  apps: [],
};
